<template>
        <div class="col-12">
             <label for="ImpactedSelection" class="mr-2">View items by: </label><br/><b-form-radio-group
                id="ImpactedSelection"
                :options="options()"
                v-model="selected"
                buttons
                button-variant="outline-primary"
                :name="ImpactedSelection"
                size="sm"
                class="pb-3"
            ></b-form-radio-group>
            <div class="flex col-12">
                <div class=" col-12 pl-0">
                    <div class="row  card justify-content-center" style=" border-radius:10px 10px 10px 10px !important; overflow-y:auto; max-height: 650px !important;" v-if="selected==='0'">
                        <b-table 
                            striped  
                            v-if="siteItems.length > 0"  
                            :hover="true"  
                            :items="siteItems" 
                            stacked="md"
                            :fields="fieldsService" 
                            :tbody-tr-class="'cursor-pointer'" 
                            @row-clicked="(item) => gotoRouter('/site/'+item.notificationlinkid)">
                            <template #cell(notificationlinkid)="data">
                                <span >
                                    {{ getSite(data.item.notificationlinkid).sitenumber }}
                                </span>
                            </template>
                            <template #cell(notificationdescription)="data">
                                <div class="text-wrap">
                                {{ data.item.notificationdescription }}
                                </div>
                            </template>
                        </b-table>
                        <div v-else>
                           <h4 class="pt-2">There are no Site issues at this time. </h4>
                        </div>
                    </div>
                    <div class="row card justify-content-center container-fluid " style=" border-radius:10px 10px 10px 10px !important; overflow-y:auto; max-height: 650px !important;" v-else>
                        <b-table v-if="serviceItems.length > 0" striped  :hover="true"  :items="serviceItems" stacked="md" :fields="fieldsService" :tbody-tr-class=" 'cursor-pointer'" @row-clicked="(item) => gotoRouter('/service/'+item.notificationlinkid)">
                            <template #cell(notificationlinkid)="data">
                                <span >
                                    {{ data.item.notificationlinkid }}
                                </span>
                            </template>
                            <template #cell(notificationdescription)="data">
                                <div class="text-wrap">
                                    {{ data.item.notificationdescription }}
                                </div>
                            </template>
                        </b-table>
                        <div v-else>
                           <h4 class="pt-2">There are no Service issues at this time. </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    name: 'itemAttentionTable',
    props: {
        userList: Array,
        searchParameter: String
    },
    components:
    {
    },
    computed: {
        siteItems(){
            return this.$store.getters.getItems.filter(thisItem => thisItem.notificationlinknode == 'site')
        },
        serviceItems(){
            return this.$store.getters.getItems.filter(thisItem => thisItem.notificationlinknode == 'service')
        },
        userprofile() {
            return this.$store.getters.getProfile
        },

    },
    filters: {
        userTypeFilter(value) {
            value = Number.parseInt(value)
            if (value === 1) {
                return "VERNet Admin"
            } else if (value === 2) {
                return "VERNet Technician"
            } else if (value === 3) {
                return "VERNet Engineering"
            } else if (value === 4) {
                return "Admin"
            } else if (value === 5) {
                return "Standard"
            } else {
                return value
            }
        }
    },
    methods: {
        gotoRouter(routerlink) {
            if(this.userprofile.type == 1 || this.userprofile.type == 4){
                this.$router.push(routerlink);
            } 
        },
        getSite(siteid){
            return this.$store.getters.getSite(siteid)
        },
        getService(serviceid){
            return this.$store.getters.getService(serviceid)
        },
        options() {
            return [
                {text: 'Sites ('+this.siteItems.length+')', value: '0'},
                {text: 'Services ('+this.serviceItems.length+')', value: '1'}
            ]
        },
    },
    data() {
        return {
            selected: '0',
            filterSelected: null,
            customerSelection: [],
            search: "",
            testList: [],
            crumbs: [
                {
                text: "Home",
                to: "/"
                },
                {
                text: "Users",
                active: true
                }
            ],
            fieldsSite: [
                { key: 'notificationlinkid', label: 'Site' },
                { key: 'notificationdescription', label: 'Issue' },
            ],
            fieldsService: [
                { key: 'notificationlinkid', label: 'Service' },
                { key: 'notificationdescription', label: 'Issue' },
            ],
            ImpactedSelection: "",
        };
    }
}
</script>
<style>
.cell-truncate-dots {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
</style>